import NavigationSearch from "./NavigationSearch";
import SafetyBanner from "./SafetyBanner";
import {NavLink,useLocation} from "react-router-dom";
import {Sparkles,Tv,Network,Grid2X2,Monitor,ArrowUpRight,ChartNoAxesCombined} from "lucide-react";
import {useLive} from "@/context/LiveContext";

const destinations=[
 {to:"/",label:"JARVIS",icon:Sparkles,end:true},
 {to:"/tv",label:"TV",icon:Tv},
 {to:"/pc",label:"PC",icon:Monitor},
 {to:"/redes",label:"Redes",icon:Network},
 {to:"/tradingos",label:"TradingOS",icon:ChartNoAxesCombined},
 {to:"/mas",label:"Más",icon:Grid2X2},
];
export default function InterfaceFrame({children}){
 const {connected,onlineAgent}=useLive();
 const {pathname}=useLocation();
 const moreActive=["/utilidades","/certificacion","/finanzas","/creacion","/vida-personal","/organizacion","/seguridad","/formularios","/codigos","/experiencia","/hoy","/mas","/modulos/","/plantas","/mi-espacio","/misiones","/ajustes"].some(p=>pathname.startsWith(p));
 return <div className="interface-frame" data-testid="interface-frame">
  <a className="interface-skip" href="#interface-content">Saltar al contenido</a>
  <aside className="interface-rail" aria-label="Navegación principal">
   <NavLink to="/" className="interface-monogram" aria-label="JARVIS · Inicio">J<span/></NavLink>
   <nav className="interface-links">{destinations.map(({to,label,icon:Icon,end})=><NavLink key={to} to={to} end={end} className={({isActive})=>"interface-link"+((isActive||(to==="/mas"&&moreActive))?" is-active":"")}><Icon size={24} aria-hidden="true"/><span>{label}</span></NavLink>)}<NavigationSearch/></nav>
   <div className="interface-rail-bottom">
    <span className={"interface-signal "+(connected?"is-online":"")} title={connected?"Canal con el servidor conectado":"Sin conexión en vivo con el servidor"}><i/><span>{connected?"EN LÍNEA":"SIN ENLACE"}</span></span>
    <NavLink to="/ajustes?tab=agente" className="interface-agent" aria-label={onlineAgent?"Ver agente conectado":"Configurar agente"}><Monitor size={18}/><span>PC</span><ArrowUpRight size={11}/></NavLink>
    <span className="interface-signature">NEXUS / OS</span>
   </div>
  </aside>
  <div id="interface-content" className="interface-content" tabIndex={-1}><SafetyBanner/>{children}</div>
 </div>;
}
